import React from 'react';
import { Paper, makeStyles, IconButton } from '@material-ui/core';
import icSearch from '../assets/icons/ic_search.png';
import { Search } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { lightBlue } from '@material-ui/core/colors';

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        width: 236,
        height: 38,
        paddingLeft: '8px',
        paddingRight: '8px',
        border: 'solid 1px ' + lightBlue[100],
    },
    iconButton: {
        padding: 0,
        width: 18,
        height: 18
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        outline: 'none',
        border: 'none',
        fontFamily: "UniviaPro",
        fontSize: "12px",
        fontWeight: "normal",
        fontStretch: "normal",
        fontStyle: "normal",
        lineHeight: "normal",
        letterSpacing: "normal",
        color: "#88898c",
        opacity: 0.9
    },
    formSearch: {
        borderRadius: '10px',
        border: ' solid 1px #e0f0f2',
        backgroundColor: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        width: 236,
        height: 38,
        paddingLeft: '8px',
        paddingRight: '8px',
    },
    border: {
        borderRadius: '10px',
        backgroundColor: '#e5f1f8',
    },

}));

const SearchInput = ({ placeholder, onChangeText, getList,disableButton }) => {
    const classes = useStyles();

    const onChange = event => {
        onChangeText(event.target.value);
    }

    const onSubmit = (e) => {
        e.preventDefault()
        getList();
    }

    return (
        <form onSubmit={onSubmit} >
            <Paper elevation={0} className={classes.formSearch}>
                <img src={icSearch} className={classes.iconButton} alt='' />
                <input className={classes.input} placeholder={placeholder} onChange={onChange} />
                {
                    !disableButton &&
                    <IconButton
                        style={{ marginLeft: '1em', padding: '6px' }}
                        className={classes.border}
                        size='small'
                        onClick={onSubmit}
                    >
                        <Search color='primary' />
                    </IconButton>
                }

            </Paper>
        </form>
    );
}

SearchInput.propTypes = {
    placeholder: PropTypes.string,
    onChangeText: PropTypes.func.isRequired,
    getList: PropTypes.func.isRequired
};

export default SearchInput;
